import { useState } from 'react';

import { Button } from '@/components/core/button';
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/core/dialog';
import { View } from '@/components/data-table/views/types';
import { useLastDefined } from '@/shared/hooks/use-last-defined';

type Props = {
  view?: View; // optional because the component is always mounted, even when no view is selected for deletion
  onDelete: () => Promise<void>;
};

export function ConfirmDeleteViewDialogContent({ view: viewProp, onDelete }: Props) {
  const view = useLastDefined(viewProp);
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteView = async () => {
    if (!view) return;
    try {
      setIsDeleting(true);
      await onDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Are you sure you want to delete the view?</DialogTitle>
        <DialogDescription>
          <em>{view?.name}</em> will be permanently deleted.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">Cancel</Button>
        </DialogClose>
        <Button variant="destructive" loading={isDeleting} onClick={deleteView}>
          Delete
        </Button>
      </DialogFooter>
    </DialogContent>
  );
}
